var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIraha(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.78 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c6634;}.cls-2{fill:#5bb67a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7100") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.19,3.72A3.71,3.71,0,1,1,8.48,0,3.72,3.72,0,0,1,12.19,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.3,18.28a2.81,2.81,0,0,1,1.64-2,3,3,0,0,1,.44-1.27,2.9,2.9,0,0,1,.38-1.39s0-.08,0-.11a15.23,15.23,0,0,1-12.23,6.16A15.29,15.29,0,0,1,.83,11.14l-.42.26a2.66,2.66,0,0,1,.17.66,2.8,2.8,0,0,1,0,.41,2.08,2.08,0,0,1,.45.72,1.52,1.52,0,0,0,.16.42,3.69,3.69,0,0,1,.11.45A2.49,2.49,0,0,1,2.38,15.9v0a1.76,1.76,0,0,1,.19.39l0,.05a2.37,2.37,0,0,1,.53.34l.06.06A2.72,2.72,0,0,1,4,17.89c0,.23.11.45.16.68a.34.34,0,0,1,0,.1l.17,0a2.83,2.83,0,0,1,2.89,1.94,3.53,3.53,0,0,1,1.22.24,2.31,2.31,0,0,1,.46,0,2.86,2.86,0,0,1,2.84,1.76,2.13,2.13,0,0,1,1.5-.67,3.22,3.22,0,0,1,2.18.78A2.17,2.17,0,0,1,16.9,22a3.47,3.47,0,0,1,1,.15,2.3,2.3,0,0,1,1.78-1,3.36,3.36,0,0,1,.71.08,2,2,0,0,1,.93-.24h.15a3,3,0,0,1,1.08-1.36A2.57,2.57,0,0,1,24.3,18.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.39,20.59A14.4,14.4,0,0,1,.11,7.87,13.77,13.77,0,0,0,0,9.58a14.39,14.39,0,1,0,28.78,0,13.77,13.77,0,0,0-.11-1.71A14.4,14.4,0,0,1,14.39,20.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 20.19,
    cy: 3.72,
    rx: 3.71,
    ry: 3.72
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraha);
export default __webpack_public_path__ + "static/media/iraha.5e9bcfab.svg";
export { ForwardRef as ReactComponent };